export function isToolbarItemAllowed(item: Readonly<{ allowed?: boolean }>) {
  return item.allowed !== false;
}
